import { EmptyState, Form, FormLayout, Select, SkeletonBodyText, Text } from '@shopify/polaris';
import { useEffect } from 'react';
import { useState } from 'react';
import { getDeposits } from '../../../services/depositsService';

const SelectDeposit = ({ delivery, onSubmit }) => {
  const [deposits, setDeposits] = useState([]);
  const [depositValue, setdepositValue] = useState('');

  useEffect(() => {
    getDeposits({ limit: 1000 })
      .then((res) => {
        const p = res.data.data.map((d) => ({ label: d.name, value: parseInt(d.id) }));
        setDeposits(p);
        setdepositValue(p[0].value);
      })
      .catch((e) => {
        throw e;
      });
  }, []);

  const handleSubmit = (e) => {
    onSubmit(depositValue);
  };

  return (
    <>
      {deposits.length === 0 && <SkeletonBodyText />}
      {deposits.length > 0 && (
        <EmptyState
          heading="¿Dónde depositamos la mercancía?"
          image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
          action={{
            content: 'Seleccionar',
            onAction: handleSubmit,
          }}
        >
          <Text>
            Hemos recibido <b>{delivery.stockQtyExpected} uds.</b> de <b>{delivery.distinctProducts} productos</b>{' '}
            diferentes.
            <br />
            Necesitamos un depósito donde transferir la mercancía
          </Text>
          <br />
          <br />
          <Text fontWeight={'bold'}>¿Podrías seleccionar un depósito?</Text>
          <br />
          <Form onSubmit={handleSubmit}>
            <FormLayout>
              <Select options={deposits} onChange={setdepositValue} value={depositValue} />
            </FormLayout>
          </Form>
        </EmptyState>
      )}
    </>
  );
};

export default SelectDeposit;
